module.exports = function ($rootScope, Restangular) {
    function StateService() {
        this._api = Restangular.one('states');

        // We invalidate on delivery address change because the state of the
        // new delivery address may have changed.
        $rootScope.$on('address-update', this.invalidate.bind(this));
    }

    let statesPromise;
    StateService.prototype.getStates = function () {
        if (statesPromise) {
            return statesPromise;
        }

        statesPromise = this._api.get().then(function (states) {
            return states.rawResponse;
        });

        return statesPromise;
    };

    StateService.prototype.invalidate = function () {
        statesPromise = null;
    };

    return new StateService();
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/address/state-service.js
 **/